export function blobToDataURL(blob: Blob) {
  return new Promise<string | null>((resolve) => {
    const reader = new FileReader()

    const handleError = () => resolve(null)

    const handleLoad = (event: ProgressEvent<FileReader>) => {
      if (!event.target || typeof event.target.result !== 'string')
        return handleError()

      resolve(event.target.result)
    }

    reader.onabort = handleError
    reader.onerror = handleError
    reader.onload = handleLoad
    reader.readAsDataURL(blob)
  })
}

export async function handleUploadSingleFile(
  file: File | Blob,
  uploadUrl: string,
  contentType?: string,
  headers: Record<string, string> = {},
) {
  if (contentType) headers['Content-Type'] = contentType

  return fetch(uploadUrl, {
    method: 'PUT',
    headers,
    body: file,
  })
    .then(({status}) => status === 200)
    .catch(() => false)
}

export function downloadImage(file: File | Blob, fileName?: string) {
  // Create an object URL from the file/blob
  const url = URL.createObjectURL(file)

  // Create a temporary <a> element
  const a = document.createElement('a')
  a.href = url

  // Set default filename if not provided
  a.download =
    fileName || (file instanceof File ? file.name : 'downloaded_image')

  // Append to body, click to trigger download, then remove
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)

  // Revoke the object URL to free memory
  URL.revokeObjectURL(url)
}
